import { INVOICE_TYPE } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const invoiceTypeListRequest = () => ({
  url: INVOICE_TYPE,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.MASTER_MS,
});

export const createInvoiceType = (invoiceTypeName) => ({
  url: INVOICE_TYPE,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: { invoiceTypeName },
  service: serviceName.MASTER_MS,
});

export const updateInvoiceType = (invoiceTypeId, invoiceTypeName, isActive) => ({
  url: INVOICE_TYPE,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: { invoiceTypeId, invoiceTypeName, isActive: Number(isActive) },
  service: serviceName.MASTER_MS,
});
